import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileCTA from "./MobileCTA";

export default function Layout() {
  return (
    <div className="min-h-screen bg-ink font-body text-white antialiased">
      <Navbar />
      <main className="pb-16 md:pb-0">
        <Outlet />
      </main>
      <div className="pb-16 md:pb-0">
        <Footer />
      </div>
      <MobileCTA />
    </div>
  );
}
